import React, { useState, useMemo, useEffect, useRef } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    CardTitle,
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
    getCompanies as onGetCompanies,
    getLkpmReportProfitLossExcel as onGetLkpmReportExcel,
    getLkpmReportProfitLossPdf as onGetLkpmReportPdf,
    previewLkpmReportProfitLossPdf as onPreviewLkpmReportProfitLossPdf
} from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";

const ReportProfitLossLKPM = () => {

    //meta title
    document.title = "LKPM ProfitLoss | Des Counts";

    const dispatch = useDispatch();

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e);
    }

    const [selectedYear, setSelectedYear] = useState(null);
    const [optionYear, setOptionYear] = useState([]);
    function handleSelectYear(e) {
        setSelectedYear(e);
    }

    const [selectedQuarter, setSelectedQuarter] = useState(null);
    const [optionQuarter, setOptionQuarter] = useState([
        { label: "I - Pertama", value: 1 },
        { label: "II - Kedua", value: 2 },
        { label: "III - Ketiga", value: 3 },
        { label: "IV - Keempat", value: 4 }
    ]);
    function handleSelectQuarter(e) {
        setSelectedQuarter(e);
    }

    const filterCompany = useRef("");
    const filterYear = useRef("");
    const filterQuarter = useRef("");

    const { companies, loadingCompany } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
    }));

    const { loading } = useSelector(state => ({
        loading: state.Report.loading
    }))

    const onDownloadReportExcel = () => {
        dispatch(onGetLkpmReportExcel({
            companyId: selectedCompany.value,
            year: selectedYear.value,
            quarter: selectedQuarter.value,
        }))
    }

    const onDownloadReportPdf = () => {
        dispatch(onGetLkpmReportPdf({
            companyId: selectedCompany.value,
            year: selectedYear.value,
            quarter: selectedQuarter.value,
        }))
    }

    const onPreviewReportPdf = () => {
        dispatch(onPreviewLkpmReportProfitLossPdf({
            companyId: selectedCompany.value,
            year: selectedYear.value,
            quarter: selectedQuarter.value,
        }))
    }

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies])

    useEffect(() => {
        dispatch(onGetCompanies({}));
        var temp = [];
        var currentYear = new Date().getFullYear();
        for (var i = 0; i < 20; i++) {
            temp.push({ label: (currentYear-i).toString(), value: currentYear-i })
        }
        setOptionYear(temp)
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Report" breadcrumbItem="LKPM ProfitLoss" />
                    {
                        loading &&
                        <div className="d-flex justify-content-center my-5">
                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                        </div>
                    }
                    {
                        !loading &&
                        <Row className="mb-3">
                            <Col xs="12">
                                <Card>
                                    <CardBody className="pt-0">
                                        <CardTitle className="my-3">Filter</CardTitle>
                                        <Row>
                                            <Col sm={4}>
                                                <div>
                                                    <Label>Company</Label>
                                                    <Select
                                                        value={selectedCompany}
                                                        onChange={handleSelectCompany}
                                                        options={optionCompany}
                                                        isLoading={loadingCompany}
                                                        ref={filterCompany}
                                                        className="select2-selection"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm={4}>
                                                <div>
                                                    <Label>Year</Label>
                                                    <Select
                                                        value={selectedYear}
                                                        onChange={handleSelectYear}
                                                        options={optionYear}
                                                        ref={filterYear}
                                                        className="select2-selection"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm={4}>
                                                <div>
                                                    <Label>Quarter</Label>
                                                    <Select
                                                        value={selectedQuarter}
                                                        onChange={handleSelectQuarter}
                                                        options={optionQuarter}
                                                        ref={filterQuarter}
                                                        className="select2-selection"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col className="justify-content-end">
                                                <Button color="primary" className="btn btn-success waves-effect waves-light float-end ms-2" style={{ minWidth: '200px' }}
                                                    disabled={!selectedCompany || !selectedYear || !selectedQuarter}
                                                    onClick={onDownloadReportExcel}
                                                >
                                                    Download Excel
                                                </Button>
                                                <Button color="danger" className="btn btn-danger waves-effect waves-light float-end ms-2" style={{ minWidth: '200px' }}
                                                    disabled={!selectedCompany || !selectedYear || !selectedQuarter}
                                                    onClick={onDownloadReportPdf}
                                                >
                                                    Download PDF
                                                </Button>
                                                <Button color="primary" className="btn btn-primary waves-effect waves-light float-end" style={{ minWidth: '200px' }}
                                                    disabled={!selectedCompany || !selectedYear || !selectedQuarter}
                                                    onClick={onPreviewReportPdf}
                                                >
                                                    Preview
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

ReportProfitLossLKPM.propTypes = {
    className: PropTypes.string,
    onGetCompanies: PropTypes.func,
    preGlobalFilteredRows: PropTypes.any,
};

export default ReportProfitLossLKPM
